<template>
	<div>
		<div class="nav-buttons-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I need help with my order</h1>
			<v-base-nav-page :links="links" :nosearch="true">
			</v-base-nav-page>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import Axios from 'axios';
	import BaseNavPage from './../components/BaseNavPage';
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "HelpWithMyOrderEBook",

		components: {
			BaseNavLinks,
			'v-base-nav-page': BaseNavPage,
		},

		data() {
			return {
				loading: false,
				is_ia_item: true
			}
		},

		computed: {
			links() {
				return [
					{
						to: '/how_to_redeem/' + parseInt(this.$route.params.id),
						caption: 'How do I redeem? / I didn’t receive this / I can’t redeem'
					},
					{
						to: '/cancel/' + parseInt(this.$route.params.id),
						caption: 'I’d like to cancel this book'
					},
					{
						to: '/want_to_extend_term/' + parseInt(this.$route.params.id),
						caption: 'I want to extend the term'
					},
					{
						to: '/wrong_ebook/' + parseInt(this.$route.params.id),
						caption: 'When I register, it says I have the wrong item',
						enabled: !this.is_ia_item
					},
					{
						to: '/why_charged_tax/' + parseInt(this.$route.params.id),
						caption: 'Why did I get charged sales tax?'
					},
					{
						to: '/meant_other_payment_method/' + parseInt(this.$route.params.id),
						caption: this.$globs.institute_info.meant_other_payment_method
					},
				];
			}
		},

		mounted() {
			const self = this;

			self.loading = true;
			Axios.get('/service/customer_help/rest/index.php/customer_help/check_if_ia_item/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						let d = response['data']['data'];
						self.is_ia_item = d['is_inclusive_access_item'];
					}
				})
				.finally(function () {
					self.loading = false;
				});
		}
	}
</script>

<style scoped>

</style>